const CONCLUSIONS = [
  'A privacidade foi integrada desde a fase de concepção do projeto?',
  'As configurações padrão garantem o nível máximo de proteção?',
  'Há Avisos de Privacidade claros e acessíveis?',
  'Há minimização de dados, ou seja, coleta apenas o necessário?',
  'Os direitos dos titulares são facilmente exercíveis?',
  'As medidas de segurança são revisadas periodicamente?',
  'Os dados são protegidos desde a coleta até o descarte?',
  'Há criptografia, controle de acesso e registro de logs implementados?',
  'O monitoramento contínuo de falhas e vulnerabilidades está ativo?',
  'Há processo formal de revisão periódica das práticas de PbD?',
  'São realizadas auditorias internas e externas de conformidade?',
]

const NON_CONFORMITY_TYPE = 'non_conformity'
const IMPROVEMENT_TYPE = 'improvement'

const privacyByDesignAuditEntity = {
  CONCLUSIONS,
  IMPROVEMENT_TYPE,
  NON_CONFORMITY_TYPE,
}

export default privacyByDesignAuditEntity
